import RequestUtils from "utils/RequestUtils";

export interface SmsBalanceRes {
  companyId: number;
  smsBalance: number;
}

export interface SmsChargeHistoryRes {
  smsChargeHistoryId: number;
  amount: number;
  status: "pending" | "succeeded" | "failed";
  createdAt: string;
  updatedAt: string;
}

export interface CreateCheckoutSessionReq {
  amount: number;
  successUrl: string;
  cancelUrl: string;
}

export interface CreateCheckoutSessionRes {
  smsChargeHistoryId: number;
  checkoutUrl: string;
}

export default class SmsBalanceApi {
  private constructor() {}

  public static async find(companyId: number): Promise<SmsBalanceRes> {
    return RequestUtils.getPlain(
      `/smsBalance/find/${companyId}`
    ) as Promise<SmsBalanceRes>;
  }

  public static async history(
    companyId: number
  ): Promise<SmsChargeHistoryRes[]> {
    return RequestUtils.getPlain(
      `/smsBalance/history/${companyId}`
    ) as Promise<SmsChargeHistoryRes[]>;
  }

  public static async createCheckoutSession(
    companyId: number,
    data: CreateCheckoutSessionReq
  ): Promise<CreateCheckoutSessionRes> {
    return RequestUtils.postPlain(
      `/smsBalance/createCheckoutSession/${companyId}`,
      data
    ) as Promise<CreateCheckoutSessionRes>;
  }
}

export const CHARGE_AMOUNTS = [1000, 3000, 5000, 10000];
